export default __webpack_public_path__ + "static/media/Team.ee4c21f3.png";